import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "@mdx-js/react";
function _createMdxContent(props) {
    const _components = Object.assign({
        div: "div",
        h3: "h3",
        pre: "pre",
        code: "code",
        p: "p",
        h4: "h4"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
        children: [
            _jsxs("div", {
                className: "w-full",
                children: [
                    _jsx(_components.h3, {
                        children: "Example"
                    }),
                    _jsx(_components.pre, {
                        children: _jsx(_components.code, {
                            className: "language-typescript",
                            children: "// Import in a single file, then across your whole project...\nimport '@total-typescript/ts-reset'\n// .filter just got smarter!\nconst filteredArray = [1, 2, undefined].filter(Boolean) // number[]\n// Get rid of the any's in JSON.parse and fetch\nconst result = JSON.parse('{}') // unknown\nfetch('/')\n  .then((res) => res.json())\n  .then((json) => {\n    console.log(json) // unknown\n  })\n"
                        })
                    }),
                    _jsx(_components.h3, {
                        children: "DOM Example"
                    }),
                    _jsx(_components.pre, {
                        children: _jsx(_components.code, {
                            className: "language-ts",
                            children: "// Import from /dom to get DOM rules too!\nimport '@total-typescript/ts-reset/dom'\n// localStorage just got safer!\nlocalStorage.abc // unknown\n// sessionStorage just got safer!\nsessionStorage.abc // unknown\n"
                        })
                    })
                ]
            }),
            "\n",
            _jsxs("div", {
                className: "w-full",
                children: [
                    _jsx(_components.h3, {
                        children: "Installing only certain rules"
                    }),
                    _jsxs(_components.p, {
                        children: [
                            "By importing from ",
                            _jsx(_components.code, {
                                children: "@total-typescript/ts-reset"
                            }),
                            ", you're bundling all the recommended rules."
                        ]
                    }),
                    _jsx(_components.p, {
                        children: "To only import the rules you want, you can import like so:"
                    }),
                    _jsx(_components.pre, {
                        children: _jsx(_components.code, {
                            className: "language-ts",
                            children: "// Makes JSON.parse return unknown\nimport '@total-typescript/ts-reset/json-parse'\n// Makes await fetch().then(res => res.json()) return unknown\nimport '@total-typescript/ts-reset/fetch'\n"
                        })
                    }),
                    _jsxs(_components.p, {
                        children: [
                            "For these imports to work, you'll need to ensure that, in your ",
                            _jsx(_components.code, {
                                children: "tsconfig.json"
                            }),
                            ", ",
                            _jsx(_components.code, {
                                children: "moduleResolution"
                            }),
                            " is set to ",
                            _jsx(_components.code, {
                                children: "NodeNext"
                            }),
                            ", ",
                            _jsx(_components.code, {
                                children: "Node16"
                            }),
                            " or ",
                            _jsx(_components.code, {
                                children: "Bundler"
                            }),
                            "."
                        ]
                    }),
                    _jsx(_components.p, {
                        children: "Below is a full list of all the rules available."
                    }),
                    _jsx(_components.h3, {
                        children: "Caveats"
                    }),
                    _jsx(_components.h4, {
                        children: "Use ts-reset in applications, not libraries"
                    }),
                    _jsxs(_components.p, {
                        children: [
                            _jsx(_components.code, {
                                children: "ts-reset"
                            }),
                            " is designed to be used in application code, not library code. Each rule you include will make changes to the global scope. That means that, simply by importing your library, your user will be unknowingly opting in to ",
                            _jsx(_components.code, {
                                children: "ts-reset"
                            }),
                            "."
                        ]
                    })
                ]
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
